import React, { useState } from 'react';
import { Check, Close } from '@icon-park/react';
import { useTranslation } from 'react-i18next';

interface AreaPropertyPanelProps {
  position: { x: number; y: number };
  initialName?: string;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

const AreaPropertyPanel: React.FC<AreaPropertyPanelProps> = ({
  position,
  initialName = '',
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [areaName, setAreaName] = useState(initialName);

  const handleConfirm = () => {
    onConfirm(areaName);
  };

  return (
    <div
      className="absolute bg-white rounded shadow-lg border border-gray-300 p-2 z-50"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: '160px',
      }}
    >
      {/* 区域名称设置 */}
      <div className="mb-2">
        <label className="block text-xs text-gray-600 mb-0.5">
          {t('elementProps.areaName')}
        </label>
        <input
          type="text"
          value={areaName}
          onChange={(e) => setAreaName(e.target.value)}
          placeholder={t('elementProps.areaNamePlaceholder')}
          className="w-full px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-primary-300"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleConfirm();
            } else if (e.key === 'Escape') {
              onCancel();
            }
          }}
        />
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-1">
        <button
          onClick={handleConfirm}
          className="flex-1 flex items-center justify-center gap-0.5 px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded hover:bg-primary-600 transition-colors"
        >
          <Check size={12} theme="outline" />
          <span className="text-[10px]">{t('dialog.confirm')}</span>
        </button>
        <button
          onClick={onCancel}
          className="flex-1 flex items-center justify-center gap-0.5 px-1.5 py-0.5 bg-gray-200 text-gray-700 text-xs rounded hover:bg-gray-300 transition-colors"
        >
          <Close size={12} theme="outline" />
          <span className="text-[10px]">{t('dialog.cancel')}</span>
        </button>
      </div>
    </div>
  );
};

export default AreaPropertyPanel;
